
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendars",
      function () {
        return require("private-next-pages/calendars.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendars"])
      });
    }
  